import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import ProbillPreview from "../common/probill-preview/probillPreview";
import XGSNavLink from "../../ui-components/xgs-nav-link/xgsNavLink";
import { AppointmentNeed, Exception } from "app/data/terminal-insights/models";
import { ManifestTableRow } from "app/data/manifest/manifestProfiles";
import { arrangeName } from "hooks/utils";
import moment from "moment";

export const getExceptionColumns = () => {
  const exceptionColumnHelper = createColumnHelper<Exception>();
  const exceptionColumns = [
    exceptionColumnHelper.accessor("probill", {
      id: "probill",
      header: "Probill",
      size: 112,
      cell: (cellProps: any) => (
        <ProbillPreview probillNumber={Number(cellProps.getValue())}>
          <span>
            <XGSNavLink
              className="xgs-table-link-cell"
              to={`/shipments/${cellProps.getValue()}`}
              target="__blank"
            >
              {cellProps.getValue()}
            </XGSNavLink>
          </span>
        </ProbillPreview>
      )
    }),
    exceptionColumnHelper.accessor("description", {
      id: "description", 
      header: "Description",
      size: 200
    }),
    exceptionColumnHelper.accessor("addedDate", {
      id: "addedDate",
      header: "Date",
      size: 120
    }),
    exceptionColumnHelper.accessor("reason", {
      id: "reason",
      header: "Reason",
      cell: (cellProps) => (
        <span>
          {cellProps.getValue()}
        </span>
      ),
      size: 120
    })
  ];
  return exceptionColumns;
}

export const getManifestTracking = () => {
const manifestColumnHelper = createColumnHelper<ManifestTableRow>();
  const manifestColumns = [
    manifestColumnHelper.accessor("manifestNumber", {
      id: "manifestNumber",
      header: "Manifest",
      cell: (cellProps) => (<>{cellProps.getValue()}</>),
      size: 120,
    }),
    manifestColumnHelper.accessor("driverName", {
      id: "driverName",
      header: "Driver",
      cell: (cellProps) => {
        return (
          <div className="cell__driver">
            {arrangeName(cellProps.getValue())}
          </div>
        )
      },
      size: 180,
    }),
    manifestColumnHelper.accessor("dispatchedTs", {
      id: "dispatchedTs",
      header: "Dispatched",
      cell: (cellProps) => {
        const date = moment(cellProps.getValue(), "MMM D YYYY hh:mm");
        return (
          <div className="cell__driver">
            {date.format("MMM D")}
            <div className="text-light">{date.format("h:mm A")}</div>
          </div>
        )
      },
      size: 120,
    }),
    manifestColumnHelper.accessor("probills", {
      id: "probills",
      header: "Deliveries",
      cell: (cellProps) => (<>{cellProps.getValue()}</>),
      size: 100,
    }),
    manifestColumnHelper.accessor("exceptions", {
      id: "exceptions",
      header: "Exceptions",
      cell: (cellProps) => (<span className={"cell__exc" + (cellProps.getValue() > 0 ? " --alert" : "")}>{cellProps.getValue()}</span>),
      size: 120,
    }),
  ];
  return manifestColumns;
}

export const getAppointmentColumns = () => {
  const appointmentColumnHelper = createColumnHelper<AppointmentNeed>();
  const appointmentColumns = [
    appointmentColumnHelper.accessor("probill", {
      id: "probill",
      header: "Probill",
      cell: (cellProps) => (
        <ProbillPreview probillNumber={Number(cellProps.getValue())}>
          <span>
            <XGSNavLink
              className="xgs-table-link-cell"
              to={`/shipments/${cellProps.getValue()}`}
              target="__blank"
            >
              {cellProps.getValue()}
            </XGSNavLink>
          </span>
        </ProbillPreview>
      ),
      size: 120
    }),
    appointmentColumnHelper.accessor("eta_date", {
      id: "eta_date",
      header: "ETA Date",
      size: 120
    }),
    appointmentColumnHelper.accessor("consignee", {
      id: "consignee",
      header: "Consignee", 
      size: 280
    }),
    appointmentColumnHelper.accessor("status", {
      id: "status",
      header: "Status",
      cell: (cellProps) => (
        <span>
          {cellProps.getValue()}
        </span>
      ),
      size: 150
    })
  ];
  return appointmentColumns;
}
